export const GRID_AREA_STUDENT_AVATAR = 'student-avatar';
